if (document.getElementById('lista-imoveis-filtros')) {
  new Vue({
    el: '#lista-imoveis-filtros',
    data: function() {
      var self = this
      $(document).on('change', '#busca-tipo', function() {
        self.setarProp('tipo', '#busca-tipo', '+')
      })
      $(document).on('change', '#busca-operacao', function() {
        self.setarProp('operacao', '#busca-operacao', '+')
      })
      $(document).on('change', '#busca-bairro', function() {
        self.setarProp('bairro', '#busca-bairro', '_')
      })
      $(document).on('change', '#busca-cidade', function() {
        self.cidade = this.value
        self.bairro = ''
      })
      $(document).on('change', '#busca-anunciante', function() {
        self.anunciante = this.value
      })
      $(document).on('change', '#busca-acomodacoes', function() {
        self.acomodacoes = this.value
      })

      $('.btn-show-filtros').click(this.openModal)

      $(document).on('change', '.form-group input, .form-group select', function() {
        if ($(this).val() != '')
          $(this)
            .closest('.form-group')
            .addClass('active')
        else
          $(this)
            .closest('.form-group')
            .removeClass('active')
      })

      $(document).on('click', '.form-group .btn-limpar-simples', function() {
        $(this)
          .closest('.form-group')
          .removeClass('active')
          .find('input, select')
          .val('')
          .trigger('change')
        self[
          $(this)
            .closest('.form-group')
            .find('input, select')
            .attr('name')
        ] = ''
        setTimeout(function() {
          self.reload()
        }, 200)
      })

      $(document).on('click', '.navigation a', function(event) {
        $('.lista-imoveis-wrapper')
          .css({ position: 'relative', overflow: 'hidden' })
          .append('<div class="overlay-loader"></div>')

        $('html,body').animate({ scrollTop: 0 }, 300)
      })

      $(document).on('change', '.reload-onchange', function(event) {
        window.location.href = this.getAttribute('data-url').replace('DATAORDENACAO', this.value)
        $('html,body').animate({ scrollTop: 0 }, 300)
        $('.lista-imoveis-wrapper')
          .css({ position: 'relative', overflow: 'hidden' })
          .append('<div class="overlay-loader"></div>')
      })
      $(document).on('change', '.reload-onchange-page', function(event) {
        window.location.href = this.value
        $('html,body').animate({ scrollTop: 0 }, 300)

        $('.lista-imoveis-wrapper')
          .css({ position: 'relative', overflow: 'hidden' })
          .append('<div class="overlay-loader"></div>')
      })

      window.addEventListener('popstate', function(event) {
        $('html,body').animate({ scrollTop: 0 }, 300)
        self.search(event.srcElement.location.href, { 'push-params': 1 })

        self.back = true
      })

      var dormitorios = []
      $('.form-select-dormitorios input:checked').each(function(i, el) {
        dormitorios.push(el.value)
      })
      var suites = []
      $('.form-select-suites input:checked').each(function(i, el) {
        suites.push(el.value)
      })
      var vagas = []
      $('.form-select-vagas input:checked').each(function(i, el) {
        vagas.push(el.value)
      })

      setTimeout(function() {
        self.getUrlParams()
      }, 500)
      return {
        operacao: $('#lista-imoveis-filtros select[name=operacao]')[0] ? $('#lista-imoveis-filtros select[name=operacao]').val() : '', //TODO verificar pra que serve isso
        // operacao:  $('#lista-imoveis-filtros input[name=operacao]:checked').val(),
        tipo: $('#lista-imoveis-filtros #busca-tipo').val(),
        cidade: $('#lista-imoveis-filtros #busca-cidade').attr('data-value'),
        bairro: $('#lista-imoveis-filtros #busca-bairro')
          .val()
          .join(','),
        page: $('#lista-imoveis-filtros input[name=page]').val(),
        preco_de: $('#lista-imoveis-filtros input[name=preco_de]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', ''),
        preco_ate: $('#lista-imoveis-filtros input[name=preco_ate]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', ''),
        area_de: $('#lista-imoveis-filtros input[name=area_de]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', ''),
        area_ate: $('#lista-imoveis-filtros input[name=area_ate]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', ''),
        codigo: $('#lista-imoveis-filtros input[name=codigo]').val(),
        dormitorios: dormitorios.join(','),
        suites: suites.join(','),
        vagas: vagas.join(','),
        anunciante: $('#lista-imoveis-filtros #busca-anunciante').attr('data-value'),
        keyword: $('#lista-imoveis-filtros input[name=keyword]').val(),
        anuncianteId: $('#lista-imoveis-filtros input[name=anunciante]')[0] ? $('#lista-imoveis-filtros input[name=anunciante]').val() : '',
        anuncianteSlug: $('#lista-imoveis-filtros input[name=anuncianteSlug]')[0]
          ? $('#lista-imoveis-filtros input[name=anuncianteSlug]').val()
          : '',
        ordenacao: $('#lista-ordenacao').val(),
        acomodacoes: $('#lista-imoveis-filtros select[name=acomodacoes]')[0]
          ? $('#lista-imoveis-filtros select[name=acomodacoes]').val()
          : '',
        timeout: null,
        xhr: null,
        first: true,
        showLimpar: false,
        back: false,
        pageloading: true,
        filtro_slug: $('#lista-imoveis-filtros input[name=filtro_slug]').val()
      }
    },

    watch: {
      operacao: function(val, oldVal) {
        this.page = 1
        this.reload()
      },
      tipo: function(val, oldVal) {
        this.page = 1
        this.reload()
      },
      cidade: function(val, oldVal) {
        this.page = 1
        this.reload()
      },
      bairro: function(val, oldVal) {
        if (window.bairro == 1) {
          this.page = 1
          this.reload()
        }
      },
      anunciante: function(val, oldVal) {
        this.page = 1
        this.reload()
      },
      keyword: function(val, oldVal) {
        this.page = 1
        this.reload()
      },
      codigo: function(val, oldVal) {
        this.codigo = val
        this.page = 1
        this.reload()
      },
      page: function(val, oldVal) {
        this.page = 1
        this.reload()
      },
      acomodacoes: function(val, oldVal) {
        this.reload()
      }
    },
    methods: {
      setarProp: function(nome, seletor, separador) {
        this[nome] = $(seletor)
          .val()
          .join(separador)
      },
      limparFiltros: function() {
        var url = ''

        if ($('.imovel-codigo-route')[0] && typeof this.codigo != 'undefiend' && this.codigo != '') {
          url = '/busca/codigo/' + this.codigo
        } else if ($('.lista-anunciante-ver-route')[0]) {
          url = '/lista-anunciantes/' + this.anuncianteSlug + '-' + this.anuncianteId
        } else if (this.filtro_slug) {
          url = '/filtro/' + this.filtro_slug
        } else {
          if (this.cidade != '') url = url + '/' + this.cidade
          else url = url + '/todas-cidades'

          if (this.operacao != '') url = url + '/' + this.operacao

          if (this.temTipo()) url = url + '/' + this.tipo
        }
        $(this.$el)
          .find('.btn-clear')
          .html('<i class="fa fa-spin fa-spinner"></i> Aguarde...')
        window.location.href = url
        return false
      },
      changeValor: function() {
        this.page = 1

        this.reload()
      },

      changeSelect: function() {
        this.page = 1

        this.reload()
      },
      changeDormitorios: function() {
        const dormitorios = []
        $('.form-select-dormitorios input:checked').each(function(i, el) {
          dormitorios.push(el.value)
        })
        this.dormitorios = dormitorios.join(',')
        this.page = 1

        this.reload()
      },

      changeSuites: function() {
        const suites = []
        $('.form-select-suites input:checked').each(function(i, el) {
          suites.push(el.value)
        })
        this.suites = suites.join(',')
        this.page = 1

        this.reload()
      },

      changeVagas: function() {
        const vagas = []
        $('.form-select-vagas input:checked').each(function(i, el) {
          vagas.push(el.value)
        })
        this.vagas = vagas.join(',')
        this.page = 1

        this.reload()
      },

      getUrlParams: function() {
        var url = ''
        var params = {}

        $('#busca-bairro').trigger('change')

        if ($('.imovel-codigo-route')[0] && typeof this.codigo != 'undefiend' && this.codigo != '') {
          url = '/busca/codigo/' + this.codigo
          if (this.cidade != '') params.cidade = this.cidade

          if (this.operacao != '') params.operacao = this.operacao

          if (this.temTipo()) params.tipo = this.tipo

          if (this.bairro != '') params.bairro = this.bairro

          if (this.dormitorios != '') {
            params.dormitorios = this.dormitorios
          }
        } else if (window.base_url_filters != '') {
          // Quando os filtros são filtros a partir da tela do Anunciante
          if ($('.imovel-codigo-route')[0]) {
            url = ''
          } else {
            url = window.base_url_filters
          }

          if (this.cidade != '') {
            url = url + '/' + this.cidade
          } else {
            url = url + '/todas-cidades'
          }

          let adicionarQuartos = this.dormitorios != ''
          if (this.operacao != '') {
            url = url + '/' + this.operacao

            if (!this.temTipo() && this.bairro == '' && adicionarQuartos) {
              url = url + '/quartos/' + this.dormitorios
              adicionarQuartos = false
            }
          }

          if (this.temTipo()) {
            url = url + '/' + this.tipo

            if (this.bairro == '' && adicionarQuartos) {
              url = url + '/quartos/' + this.dormitorios
              adicionarQuartos = false
            }
          }

          if (this.bairro != '') {
            url = url + '/' + this.bairro

            if (adicionarQuartos) {
              url = url + '/quartos/' + this.dormitorios
              adicionarQuartos = false
            }
          }

          if (adicionarQuartos) {
            url = url + '/quartos/' + this.dormitorios
            adicionarQuartos = false
          }
        } else {
          if (this.cidade != '') url = url + '/' + this.cidade
          else url = url + '/todas-cidades'

          let adicionarQuartos = this.dormitorios != ''
          if (this.operacao != '') {
            url = url + '/' + this.operacao

            if (!this.temTipo() && this.bairro == '' && adicionarQuartos) {
              url = url + '/quartos/' + this.dormitorios
              adicionarQuartos = false
            }
          }

          if (this.temTipo()) {
            url = url + '/' + this.tipo

            if (this.bairro == '' && adicionarQuartos) {
              url = url + '/quartos/' + this.dormitorios
              adicionarQuartos = false
            }
          }

          if (this.bairro != '') {
            url = url + '/' + this.bairro

            if (adicionarQuartos) {
              url = url + '/quartos/' + this.dormitorios
              adicionarQuartos = false
            }
          }

          if (adicionarQuartos) {
            url = url + '/quartos/' + this.dormitorios
            adicionarQuartos = false
          }
        }

        if (this.page > 1) params.page = this.page
        if (this.ordenacao != '') params.ordenacao = this.ordenacao
        if (this.preco_de != '' || this.preco_ate != '')
          params.valor =
            this.preco_de
              .replace('.', '')
              .replace('.', '')
              .replace('.', '')
              .replace('.', '') +
            '-' +
            this.preco_ate
              .replace('.', '')
              .replace('.', '')
              .replace('.', '')
              .replace('.', '')
        if (this.area_de != '' || this.area_ate != '')
          params.area =
            this.area_de
              .replace('.', '')
              .replace('.', '')
              .replace('.', '')
              .replace('.', '') +
            '-' +
            this.area_ate
              .replace('.', '')
              .replace('.', '')
              .replace('.', '')
              .replace('.', '')
        if (this.suites != '') params.suites = this.suites
        if (this.vagas != '') params.vagas = this.vagas
        if (this.anunciante != '' && typeof this.anunciante != 'undefined') params.anunciante = this.anunciante
        if (this.keyword != '' && this.keyword !== undefined) params.keyword = this.keyword
        if (this.acomodacoes != '') params.acomodacoes = this.acomodacoes

        if (Object.keys(params).length > 0 || this.bairro != '') this.showLimpar = 1

        return { url: url, params: params }
      },
      openModal: function() {
        $('html,body')
          .stop()
          .animate({ scrollTop: 0 }, 300)
        $('#lista-imoveis-filtros').show()

        $('.btn-aplicar-filtros').off('click')
        $('.btn-aplicar-filtros').click(this.searchClick)

        return false
      },
      searchClick: function() {
        $('html,body')
          .stop()
          .animate({ scrollTop: 0 }, 300)

        $('.lista-imoveis-wrapper .overlay-loader').remove()

        this.preco_de = $('#lista-imoveis-filtros input[name=preco_de]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
        this.preco_ate = $('#lista-imoveis-filtros input[name=preco_ate]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
        this.area_de = $('#lista-imoveis-filtros input[name=area_de]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
        this.area_ate = $('#lista-imoveis-filtros input[name=area_ate]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')

        var self = this

        var compilado = this.getUrlParams()

        $('#lista-imoveis-filtros').hide()
        self.search(compilado.url, compilado.params)

        return false
      },

      reload: function(validate = 1) {
        if ($(window).width() < 1200 && validate) {
          return false
        }

        this.preco_de = $('#lista-imoveis-filtros input[name=preco_de]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
        this.preco_ate = $('#lista-imoveis-filtros input[name=preco_ate]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
        this.area_de = $('#lista-imoveis-filtros input[name=area_de]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
        this.area_ate = $('#lista-imoveis-filtros input[name=area_ate]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')

        $('.lista-imoveis-wrapper .overlay-loader').remove()
        clearTimeout(this.timeout)

        var self = this

        var compilado = this.getUrlParams()

        this.timeout = setTimeout(function() {
          self.search(compilado.url, compilado.params)
        }, 600)
      },
      search: function(url, params = {}, url2 = null) {
        if (this.pageloading == 1) {
          return false
        }

        var paramsurl = Object.keys(params)
          .map(function(k) {
            if (k == 'push-params') return ''
            return encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
          })
          .join('&')

        var url2 = url + (paramsurl != '' ? '?' + paramsurl : '')

        if (window.location.pathname + window.location.search == url2) return

        if (!this.back) {
          history.pushState(params, document.title, url2)
        }

        this.back = false

        // ga('send', 'pageview', url2);

        var self = this
        if (self.xhr != null) {
          $('.lista-imoveis-wrapper .overlay-loader').remove()
          self.xhr.abort()
        }

        $('.lista-imoveis-wrapper')
          .css({ position: 'relative', overflow: 'hidden' })
          .append('<div class="overlay-loader"></div>')

        params.ajax = 1

        self.xhr = $.ajax({
          url: url,
          data: params
        }).done(function(data) {
          $('.lista-imoveis-wrapper')
            .css({ position: '', overflow: '' })
            .html(data)

          $('.lista-imoveis-wrapper .owl-carousel').owlCarousel({
            items: 1,
            lazyLoad: true,
            loop: true,
            dots: false,
            nav: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
          })
          $('.lista-imoveis-wrapper .select2').select2()

          $('.load-content').each(function(index, el) {
            var url = $(this).attr('data-href')
            if (
              $(this)
                .attr('data-href')
                .indexOf('?') >= 0
            )
              url = url + '&width=' + $(window).width()
            else url = url + '?width=' + $(window).width()

            $(this).load(url, function() {
              $(el).removeClass('load-content')
            })
          })

          self.xhr.abort()
        })

        if (paramsurl == '') paramsurl = '1=1'
        paramsurl += '&tipo=filtros-300x600'
        paramsurl += '&limit=1'
        paramsurl += '&titulo=1'
        paramsurl += '&redirect=1'
        paramsurl += '&cidade=' + this.cidade
        paramsurl += '&tipo_imovel=' + this.tipo
        paramsurl += '&tipo_negocio=' + this.operacao
        paramsurl += '&bairro=' + this.bairro
        paramsurl += '&width=' + $(window).width()

        if (this.dormitorios != '') {
          paramsurl += '&dormitorios=' + this.dormitorios
        }

        if (this.bairro != '') {
          paramsurl += '&bairro=' + this.bairro
        }

        if ($('#busca-anunciante')[0]) createSelect2Load($('#busca-anunciante')[0], this.anunciante)

        let element = $('.lista-imoveis-filtros .publicidade')[0]

        if (element != undefined) {
          $('.lista-imoveis-filtros .publicidade').attr(
            'data-href',
            $('.lista-imoveis-filtros .publicidade')
              .attr('data-href')
              .split('?')[0] +
              '?' +
              paramsurl
          )
          loadDivContent($('.lista-imoveis-filtros .publicidade')[0])
        }
      },
      temTipo: function() {
        return this.tipo && this.tipo.length
      }
    },

    mounted() {
      var self = this

      self.setarProp('tipo', '#busca-tipo', '+')
      self.setarProp('operacao', '#busca-operacao', '+')
      self.setarProp('bairro', '#busca-bairro', '_')

      setTimeout(function() {
        self.pageloading = false
      }, 2500)
    }
  })
}
